import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UserPrinter, UserPrinterService } from '../../../../app-shared';
import { BaseComponent, FormlyService, GridService, ModalService, NotificationService } from '../../../../tms-shared';
import { UserPrintersCreateModalComponent } from '../user-printers-create-modal/user-printers-create-modal.component';
import { UserPrintersEditModalComponent } from '../user-printers-edit-modal/user-printers-edit-modal.component';

@Component({
  selector: 'app-user-printers',
  templateUrl: './user-printers.component.html',
  styleUrl: './user-printers.component.scss',
})
export class UserPrintersComponent extends BaseComponent implements OnInit {
  model$: Observable<UserPrinter[]>;

  @Input() userId: string;

  fields: FormlyFieldConfig[];

  columnDefs: ColDef[] = [
    this.gridService.text('printerName', $localize`Name`),
    this.gridService.text('printerAddress', $localize`Address`),
  ];
  constructor(
    public userPrinterService: UserPrinterService,
    private gridService: GridService,
    private formlyService: FormlyService,
    private modalService: ModalService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    if (!this.userId) {
      this.userId = this.route.snapshot.paramMap.get('id');
    }
    this.getModel();
  }

  getModel() {
    this.model$ = this.userPrinterService.getForUser(this.userId);
  }

  create() {
    this.openUserPrinters(undefined, undefined, this.userId, true);
  }

  edit(model: UserPrinter) {
    this.openUserPrinters(model, model.id);
  }

  delete(model: UserPrinter) {
    this.userPrinterService
      .delete(model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.getModel(),
        error: () => this.notificationService.fail($localize`Check no documents linked to users printer`),
      });
  }

  private openUserPrinters(model: UserPrinter, id: string, userId?: string, create = false) {
    const { modal, component } = create
      ? this.modalService.openMedium<UserPrintersCreateModalComponent>(UserPrintersCreateModalComponent)
      : this.modalService.openMedium<UserPrintersEditModalComponent>(UserPrintersEditModalComponent);
    component.model = model;
    component.id = id;
    component.userId = userId;
    modal.result.then(
      () => this.getModel(),
      () => {},
    );
  }
}
